module.exports = __webpack_public_path__ + "img/expertchat-563.85cfdc66.png";